<template>
  <div>
    <b-dropdown
      size="sm"
      lazy
      variant="link-info"
      toggle-class="text-decoration-none"
      boundary="window"
    >
      <template #button-content>
        <span class="text-dark text-content">カラム表示</span>
      </template>
      <div class="tableHeader">
        <label
          class="custom_checkbox"
          v-for="(label, labelIndex) in tableLabels"
          :key="labelIndex"
        >
          <input
            type="checkbox"
            :value="label.displayFlag"
            @change="onChangeDisplay($event, label)"
            :checked="label.displayFlag"
          />
          <span class="label_name">{{ label.itemName }}</span>
          <span class="checkmark"></span>
        </label>
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  props: {
    tableLabels: Array
  },
  mounted() {},
  methods: {
    async onChangeDisplay(e, obj) {
      let data = {...obj}
      Vue.set(data, 'displayFlag', e.target.checked ? 1 : 0)
      // オブジェクトをDeepCopyしてmstGenCodeの削除
      var copyObj = JSON.parse(JSON.stringify(data))
      delete copyObj['mstGenCode']
      this.$emit('header-display', data)
    }
  }
}
</script>

<style lang="scss" scoped>
ul.dropdown-menu-right {
  width: 230px;
  max-height: calc(100vh - 200px);
  overflow: auto;
}
.tableHeader {
  width: 15vw;
  min-width: 200px;
  @include responsive-fs(14);
  line-height: 28px;
  padding: 0 12px;
  max-height: 300px;
  overflow: auto;
  .custom_checkbox {
    width: 100%;
    height: auto;
    @include responsive-fs(14);
    padding-left: 25px;
    user-select: none;
    margin: 12px 0;
    line-height: 1.2;
    .label_name {
      vertical-align: middle;
      word-break: break-all;
      text-align: justify;
    }
    .checkmark {
      top: 50%;
      transform: translateY(-50%);
    }
  }
}

.text-content {
  @include responsive-fs(12);
}
</style>



// WEBPACK FOOTER //
// src/components/custom-components/TableHeaderDisplayButton.vue